import styled, { css } from "styled-components";
export { ReactComponent as Play } from "assets/images/play.svg";
export { ReactComponent as Pause } from "assets/images/pause.svg";

interface ButtonProps {
  playing: boolean;
}

export const Button = styled.button.attrs({ type: "button" })<ButtonProps>`
  width: 65px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  position: absolute;
  z-index: 99;
  transition: 300ms ease;

  ${({ playing }) =>
    playing &&
    css`
      animation-delay: 1s;
      animation-name: fadeOut;
      animation-duration: 700ms;
      animation-timing-function: ease-in-out;
      animation-direction: alternate;
      animation-fill-mode: both;

      @keyframes fadeOut {
        0% {
          opacity: 1;
        }

        100% {
          opacity: 0;
        }
      }
    `}

  &:hover {
    background-color: #10adef;
    opacity: 1 !important;
  }
`;
